// import _ from "lodash";
import { SEEAS_FETCH } from "../actions/seeaActions";

import { TreeType } from "../models/ecosystemService";

const seeaReducer = (state: TreeType[] = [], action: any) => {
  switch (action.type) {
    case SEEAS_FETCH:
      return action.payload;
    default:
      return state;
  }
};

export default seeaReducer;
